<template>
    <div class="octo-modal fly" :class="[FlyModalClass, baseClass()]"
        @mousedown.prevent="startDragFlyModal"
        @click="increaseZIndex">
        <div class="omodal">
            <div class="header flex justify-between items-center">
                <div ref="added" v-if="voteLive">
                    <slot name="added"></slot>
                </div>
                <div class="title"><slot name="header" :showVoteLive="showVoteLive" ></slot></div>
                <div class="shortcuts flex items-center *:rounded-[50%] *:leading-[25px] *:w-[30px] text-center *:m-0.5">
                    <div @click="minimize()" v-if="format != 'min'"><fa icon="window-minimize" /></div>
                    <div @click="smallize()" v-if="format != 'small'"><fa icon="window-restore" /></div>
                    <div @click="maximize()" v-if="format != 'full'"><fa icon="window-maximize" /></div>
                    <div @click="closeAction()"><fa icon="times"  /></div>
                </div>
            </div>
            <div :id="`fly-modal-overlay-${keep.ID}`" class="fly-modal-overlay"></div>
            <div class="content" ref="content">
                <slot></slot>
            </div>
            <div ref="footer">
                <slot name="footer"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {
    data(){ return {
        format: 'small',
        dragIsStart: false,
        iPosX: undefined,
        iPosY: undefined,
        iNewX: undefined,
        iNewY: undefined,
        offsetLeft: undefined,
        offsetTop: undefined,
        rPosX: undefined,
        rPosY: undefined,
        rNewX: undefined,
        rNewY: undefined,
        locked: false,
        refFlyModal: '',
        index: '',
    }},
    props: {
        iFormat: {type: String },
        showVoteLive: { type: Boolean, default: false},
        voteLive: { type: Boolean, default: false}
    },
    emits: ['doCloseAction'],
    computed: {
        ...mapState("App", ["flyModalIndex"]),
        FlyModalClass(){ return this.format; },
    },
    mounted() {
        this.refFlyModal = document.getElementById(this.keep.ID);
        window.addEventListener("mouseup", this.stopDragFlyMOdal);
        window.addEventListener("mousemove", (e) => { this.dragFlyModal(e); });
        this.emitter.on('closeFlyModal', (payload) => {
            if (payload.ID == this.keep.ID) {
                this.closeAction();
            }
        });
    },
    methods: {
        ...mapActions('App', ['incFlyModal']),
        increaseZIndex() {
            this.incFlyModal()
            this.index = this.flyModalIndex;
            this.refFlyModal.style.zIndex = this.index;
        },
        checkLeft(size){ return size < 0 ? 0 : size; },
        checkTop(size){ return size < 0 ? 0 : size; },
        startDragFlyModal(e) {
            this.increaseZIndex();
            document.getElementById(`fly-modal-overlay-${this.keep.ID}`).style.visibility = "visible";
            this.iPosX = e.clientX;
            this.iPosY = e.clientY;
            this.dragIsStart = true;
        },
        dragFlyModal(e) {
            if(this.dragIsStart && this.format == 'small') {
                var h = 0;
                var w = 0;
                if(window.innerWidth !== undefined && window.innerHeight !== undefined) {
                    w = window.innerWidth;
                    h = window.innerHeight;
                } else {
                    w = document.documentElement.clientWidth;
                    h = document.documentElement.clientHeight;
                }
                if (e.clientX < w && e.clientY < h) {
                    this.iNewX = this.iPosX - e.clientX;
                    this.iNewY = this.iPosY - e.clientY;
                    this.iPosX = e.clientX;
                    this.iPosY = e.clientY;
                    var left = (this.refFlyModal.offsetLeft - this.iNewX);
                    var top = (this.refFlyModal.offsetTop - this.iNewY);
                    this.refFlyModal.style.left = this.checkLeft(left) + "px";
                    this.refFlyModal.style.top = this.checkTop(top) + "px";
                    this.offsetLeft = this.refFlyModal.offsetLeft;
                    this.offsetTop = this.refFlyModal.offsetTop;
                }
            }
        },
        stopDragFlyMOdal() {
            document.getElementById(`fly-modal-overlay-${this.keep.ID}`).style.visibility = "hidden";
            this.dragIsStart = false;
        },

        // Resize
        startResizeFlyModal(e) {
            this.rPosX = e.clientX;
            this.rPosY = e.clientY;
            this.ResizeIsStart = true;
        },
        resizeFlyModal(e) {
            if(this.ResizeIsStart && this.format == 'small') {
                this.rNewX = this.rPosX - e.clientX;
                this.rNewY = this.rPosY - e.clientY;
                this.rPosX = e.clientX;
                this.rPosY = e.clientY;
                this.refFlyModal.style.maxHeight = (this.refFlyModal.offsetLeft - this.rNewX) + "px";
                this.refFlyModal.style.maxWidth = (this.refFlyModal.offsetTop - this.rNewY) + "px";
            }
        },
        stopResizeFlyMOdal() {
            this.ResizeIsStart = false;
        },

        // Format
        minimize(){
            this.refFlyModal.style.left = null;
            this.refFlyModal.style.top = null;
            this.refFlyModal.style.bottom = "0px";
            this.refFlyModal.style.right = "0px";
            this.format = 'min';
            this.emitter.emit('retrieveFlyModalClass', { format: this.format, ref: this.refFlyModal });
        },
        smallize(){
            this.format = 'small';
            this.refFlyModal.style.bottom = null;
            this.refFlyModal.style.right = null;
            this.refFlyModal.style.left = this.offsetLeft + "px";
            this.refFlyModal.style.top = this.offsetTop + "px";
            this.emitter.emit('retrieveFlyModalClass', { format: this.format, ref: this.refFlyModal });
        },
        maximize(){
            this.refFlyModal.style.bottom = null;
            this.refFlyModal.style.right = null;
            this.refFlyModal.style.left = "0px";
            this.refFlyModal.style.top = "0px";
            this.format = 'full';
            this.emitter.emit('retrieveFlyModalClass', { format: this.format, ref: this.refFlyModal });
        },
        closeAction() {
            this.$emit('doCloseAction', this.keep);
            this.doIt();
            window.removeEventListener("mouseup", this.stopDragFlyMOdal);
            window.removeEventListener("mousemove", (e) => { this.dragFlyModal(e); });
        }
    }
}
</script>
